import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ElementRef, Renderer2, ViewChild, AfterContentChecked } from '@angular/core';
import { CfetBaseComponent, ErrorService } from '../../cfet-core';

@Component({
    selector: 'app-alert-error',
    templateUrl: './alert-error.component.html',
    styleUrls: ['./alert-error.component.scss'],
    standalone: false
})
export class AlertErrorComponent extends CfetBaseComponent implements OnInit, AfterContentChecked {

  errorMsg: string;
  showErr: boolean;
  invalidErrorDomain: boolean;
  returnurl = '';
  messages = [];
  showInfoLink = { anchorLink: '', anchorText: '' };
  hideXicon: boolean;
  flag: boolean;
  @ViewChild('closeBtn') closeBtnElement: ElementRef;

  constructor(private errorService: ErrorService,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2
  ) {
    super();
    this.errorService.showError.subscribe((v) => {
      this.showErr = v;
      if (this.showErr) {
        this.flag = true;
      }

    });
    this.errorService.errorMessage.subscribe((messages) => {
      this.messages = [];
      if (Array.isArray(messages)) {
        this.messages = messages;
      } else {
        this.messages.push(messages);
      }
    });
    this.errorService.showInfoLink.subscribe((showInfoLink) => {
      if (showInfoLink !== null) {
        this.showInfoLink = showInfoLink;
      }
    });
    this.errorService.hideXicon.subscribe((hideXicon) => {
      if (hideXicon !== null && hideXicon !== undefined) {
        this.hideXicon = hideXicon;
      }
    });
  }

  ngOnInit () {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params['loginUrl']) {
        this.returnurl = params['loginUrl'];
      }
    });
    if (this.returnurl && this.returnurl.indexOf('http') === -1) {
      this.returnurl = window.location.protocol + '//' + this.returnurl;
    }
    const urlFormat: any = this.returnurl ? new URL(this.returnurl) : '';
    const consolidatedUrl = (urlFormat.origin === 'null') ? urlFormat.pathname : urlFormat.origin;

    this.invalidErrorDomain = (consolidatedUrl && (consolidatedUrl.indexOf('firstnet.com') === -1)
      && (consolidatedUrl.match(/(^|\W)att.com($|\W)/) === null) && (consolidatedUrl.indexOf('com.att.firstnet') === -1)
      && (consolidatedUrl.indexOf('mcptt.samsung.com') === -1));
    sessionStorage.setItem('invalidErrorDomain', (JSON.stringify(this.invalidErrorDomain)));
    if (this.showInfoLink && this.showInfoLink.anchorLink && this.showInfoLink.anchorText) {
      this.invalidErrorDomain = false;
    }
  }

  ngAfterContentChecked () {
    if (this.closeBtnElement && this.flag) {
      this.renderer.selectRootElement(this.closeBtnElement.nativeElement).focus();
      this.flag = false;
    }
  }

  redirectNow (url) {
    window.location.href = url;
  }

  dismissMe (): void {
    this.showErr = false;
    this.errorService.showError.next(false);
  }

  returnToLogin () {
    sessionStorage.removeItem('ngStorage-httpHeaders');
  }
}
